<template>
  <div class="herbs-section">
    <div v-for="(h, i) in $store.state.plot.localization.herbs" class="md-layout md-gutter" :key="i">
      <div class="md-layout-item md-size-90" v-if="h !== null">
        <md-field>
          <select v-model="h.type" name="type">
            <option disabled value="">{{ $t("localization.herbsType") }}</option>
            <option v-for="(type, id) in herbsTypeList" :value="id" :key="id">{{ type }}</option>
          </select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-10" v-if="h !== null">
        <md-icon @click.native="removeHerbs(i)" v-show="btn.rm">clear</md-icon>
      </div>

      <div class="md-layout-item md-size-80" v-if="h !== null">
        <md-field>
          <std-autocomplete
            v-if="loadSpecie"
            :data="specieList"
            :label="$t('localization.herbsSpecie')"
            :initialValue="h.specie"
            :initialDisplay="initSpecie[i]"
            :index="i"
            :group="h.type"
            @result="getSpecie"></std-autocomplete>
        </md-field>
      </div>

      <div class="md-layout-item md-size-20" v-if="h !== null">
        <md-field :class="!checkPercentage(h.area) ? 'md-invalid' : ''" style="margin-top: 12px">
          <label for="herbsArea">{{ $t("localization.herbsArea") }} %</label>
          <md-input type="number" name="herbsArea" v-model="h.area" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter md-alignment-center-center">
      <md-button class="md-raised md-primary" @click="addHerbs()" v-show="btn.add">{{ $t("global.add") }} {{ $t('localization.herbs') }}</md-button>
    </div>
  </div>
</template>

<script>
import StdAutocomplete from '@/components/StdAutocomplete'

import { getDomain } from '@/assets/scripts/domainsManager'
import { checkPercentage, getValue, formatList } from '@/assets/scripts/formatData'

const HERBS_TYPE = 'herbs_type'
const HERBS_SPECIE = 'herbs_specie'

export default {
  name: 'Herbs',
  props: ['edit'],
  components: {
    StdAutocomplete
  },
  data: () => ({
    herbsTypeList: {},
    specieList: {},
    btn: {
      rm: false,
      add: true
    },
    initSpecie: [],
    loadSpecie: false,
    checkPercentage: checkPercentage
  }),
  mounted () {
    this.setLists()
    this.setHerbs()
  },
  methods: {
    setLists: function () {
      getDomain(HERBS_TYPE).then(data => {
        this.herbsTypeList = data[this.$i18n.locale]
      })
      getDomain(HERBS_SPECIE).then(data => {
        this.specieList = data[this.$i18n.locale]
        if (this.edit && this.$store.state.plot.localization.herbs[0].type.length > 0) {
          this.$store.state.plot.localization.herbs.forEach((herbs, i) => {
            this.initSpecie[i] = getValue(formatList(this.specieList[herbs.type]), herbs.specie)
          })
        }
        this.loadSpecie = true
      })
    },

    addHerbs: function () {
      this.$store.state.plot.localization.herbs.push({ ...this.$store.state.plot.herb })
      this.btn.rm = true
      if (this.getLength() === 3) {
        this.btn.add = false
      }
    },

    removeHerbs: function (index) {
      this.$set(this.$store.state.plot.localization.herbs, index, null)
      this.btn.add = true
      if (this.getLength() === 1) {
        this.btn.rm = false
      }
    },

    setHerbs: function () {
      if (this.getLength() > 1) {
        this.btn.rm = true
        if (this.getLength() === 3) {
          this.btn.add = false
        }
      }
    },

    getSpecie: function (value, index) {
      this.$store.state.plot.localization.herbs[index].specie = value
    },

    getLength: function () {
      let length = 0
      this.$store.state.plot.localization.herbs.filter(el => {
        if (el != null) length++
      })

      return length
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .herbs-section {
    margin-left: 20px;
    margin-right: 20px;
    width: 100%;
  }
</style>
